import React from 'react';
import { medicalHistory } from './ExtractProperties';
import { MHItem } from '../../store/types/medicalHistory';

const MedicalHistoryCommonItemsIcon: React.FC<{
    status?: string;
    onClickIcon?: () => void;
    onClickText?: () => void;
    statusMessage?: string;
    text?: string;
    cssBodyClass?: string;
    cssHeightClass?: string;
    cssTextClass?: string;
    medicalHistoryConfigCommonItemsData?: MHItem;
    hideIcon?: boolean;
}> = ({
    status,
    onClickIcon,
    onClickText,
    statusMessage,
    text,
    cssBodyClass,
    cssHeightClass,
    medicalHistoryConfigCommonItemsData,
    cssTextClass,
    hideIcon,
}) => {
    const details = medicalHistoryConfigCommonItemsData
        ? medicalHistory(medicalHistoryConfigCommonItemsData)
        : '';
    return (
        <div
            className={`flex cursor-pointer relative select-none items-center space-x-8 frequently-item-mh my-1 ${
                cssBodyClass || 'mr-20  group'
            } ${status || ''}`}
        >
            {!hideIcon && (
                <div
                    className={`flex cursor-pointer items-center justify-center ${
                        cssHeightClass ||
                        'min-w-32 min-h-32 w-32 h-32 text-12 group-hover:bg-darwin-neutral-100'
                    } rounded-full bg-darwin-neutral-50 toggler`}
                    onClick={onClickIcon}
                >
                    <div className="flex items-center space-x-2">
                        <p
                            className={`${
                                cssTextClass || 'heading-2'
                            } bold text-darwin-neutral-1000`}
                        >
                            {statusMessage}
                        </p>
                        <div className="flex items-center justify-center w-6 h-10">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 320 512"
                                className="w-6 h-10 fill-darwin-neutral-500"
                            >
                                <path d="M27.66 224h264.7c24.6 0 36.89-29.78 19.54-47.12l-132.3-136.8c-5.406-5.406-12.47-8.107-19.53-8.107c-7.055 0-14.09 2.701-19.45 8.107L8.119 176.9C-9.229 194.2 3.055 224 27.66 224zM292.3 288H27.66c-24.6 0-36.89 29.77-19.54 47.12l132.5 136.8C145.9 477.3 152.1 480 160 480c7.053 0 14.12-2.703 19.53-8.109l132.3-136.8C329.2 317.8 316.9 288 292.3 288z"></path>
                            </svg>
                        </div>
                    </div>
                </div>
            )}
            <div className={`min-w-64 relative ${details ? 'pb-16' : ''}`}>
                <p onClick={onClickText} className="font-700 break-all">
                    {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                    {/* @ts-ignore */}
                    {typeof text === 'string' ? text : text?.name || ''}
                </p>

                <span className="whitespace-normal absolute bottom-0 text-12 text-darwin-neutral-800 truncate-overflow-1">
                    {details}
                </span>
            </div>
        </div>
    );
};

export default MedicalHistoryCommonItemsIcon;
